export const FLYBITS = {
    IDP_HOST: process.env.REACT_APP_FLYBITS_IDP_HOST,
    FLYBITS_HOST: process.env.REACT_APP_FLYBITS_HOST,
    FLYBITS_PROXY_HOST: process.env.REACT_APP_FLYBITS_PROXY_HOST
}




// WEBPACK FOOTER //
// ./src/constants/index.tsx